import logo from './logo.svg';
import './App.css';
import TopNav from './components/sections/TopNav'
import VerificationOption from './components/sections/VerificationOption'

const App = () => {
  return (
    <div className="App">
      <TopNav />
      <VerificationOption />
    </div>
  );
}

export default App;
